import dayjs from 'dayjs'

import type { DateRangeOption } from '../../../../analyticsModule/components/tools/AnalyticsDateRangeSelect/AnalyticsDateRangeSelect.types'

export const DEFAULT_DATE_RANGE_INDEX = 2

export const dateRangeOptions: DateRangeOption[] = [
  {
    label: 'Today',
    value: 'today',
    dates: [dayjs().startOf('day').toDate(), dayjs().endOf('day').toDate()],
  },
  {
    label: 'Yesterday',
    value: 'yesterday',
    dates: [
      dayjs().subtract(1, 'day').startOf('day').toDate(),
      dayjs().subtract(1, 'day').endOf('day').toDate(),
    ],
  },
  {
    label: 'Last 7 days',
    value: 'last7days',
    dates: [dayjs().subtract(6, 'day').startOf('day').toDate(), dayjs().endOf('day').toDate()],
  },
  {
    label: 'Last 30 days',
    value: 'last30days',
    dates: [dayjs().subtract(29, 'day').startOf('day').toDate(), dayjs().endOf('day').toDate()],
  },
  {
    label: 'Last 90 days',
    value: 'last90days',
    dates: [dayjs().subtract(89, 'day').startOf('day').toDate(), dayjs().endOf('day').toDate()],
  },
  {
    label: 'Week to date',
    value: 'weekToDate',
    dates: [dayjs().startOf('week').toDate(), dayjs().endOf('day').toDate()],
  },
  {
    label: 'Month to date',
    value: 'monthToDate',
    dates: [dayjs().startOf('month').toDate(), dayjs().endOf('day').toDate()],
  },
  {
    label: 'Year to date',
    value: 'yearToDate',
    dates: [dayjs().startOf('year').toDate(), dayjs().endOf('day').toDate()],
  },
  {
    label: 'Last month',
    value: 'lastMonth',
    dates: [
      dayjs().subtract(1, 'month').startOf('month').toDate(),
      dayjs().subtract(1, 'month').endOf('month').toDate(),
    ],
  },
  {
    label: 'Last year',
    value: 'lastYear',
    dates: [
      dayjs().subtract(1, 'year').startOf('year').toDate(),
      dayjs().subtract(1, 'year').endOf('year').toDate(),
    ],
  },
]
